import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map, pipe, take, UnaryFunction, Observable } from 'rxjs';
import { authState } from 'rxfire/auth';
import { User } from 'firebase/auth';
import { AUTH } from '@core/firebase/firebase-auth.token';

export type AuthPipe = UnaryFunction<Observable<User | null>, Observable<boolean | string | any[]>>;
export type AuthPipeGenerator = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => AuthPipe;

const loggedIn: AuthPipe = map((user) => !!user);

export const redirectUnauthorizedTo = (redirect: string | any[]): AuthPipe =>
    pipe(loggedIn, map((isLoggedIn) => isLoggedIn || redirect));

export const redirectLoggedInTo = (redirect: string | any[]): AuthPipe =>
    pipe(loggedIn, map((isLoggedIn) => (isLoggedIn && redirect) || true));

export const firebaseAuthGuard: CanActivateFn = (next, state) => {
    const router = inject(Router);
    const auth = inject(AUTH);
    const authPipeFactory: AuthPipeGenerator = next.data?.['authGuardPipe'] || (() => loggedIn);

    return authState(auth).pipe(
        take(1),
        authPipeFactory(next, state),
        map((can) => {
            if (typeof can === 'boolean') return can;
            if (Array.isArray(can)) return router.createUrlTree(can);
            return router.parseUrl(can as string);
        })
    );
};
